import { useState, ReactNode } from 'react'
import { VersionContext } from './versionContext'

export function VersionProvider({ children }: { children: ReactNode }) {
  const [version, setVersion] = useState('latest')

  return <VersionContext.Provider value={{ version, setVersion }}>{children}</VersionContext.Provider>
}
